import { type HttpHandler, HttpResponse, http } from 'msw';
import { type Product } from '../../../../utils/api/types/access-api-types';
import { prependApiBase } from '../../../../__test__/utils/prepend-api-base';
import { mockError } from '../../../../__test__/utils/msw-mock-error';
import { mockProductResponse } from '../use-get-product-by-access-code-api/use-get-product-by-access-code-api.mock';

const getProductByProductCodeApiUrl = () =>
  prependApiBase(`/products/code/:productCode`, '/fulfillment', '/v2');

// A magazine product (groupCode 'CM') — magazine app codes equal their product code.
export const mockProductByCodeResponse: Product = {
  ...mockProductResponse,
  productCode: 'scope',
  productName: 'Scholastic Scope',
  applicationCode: 'scope',
  groupCode: 'CM',
};

export const getProductByProductCodeApiMock = (): HttpHandler =>
  http.get(getProductByProductCodeApiUrl(), () =>
    HttpResponse.json(mockProductByCodeResponse)
  );

export const getProductByProductCodeApiErrorMock = (): HttpHandler =>
  http.get(getProductByProductCodeApiUrl(), mockError);
